import axios from 'axios';
import { useCookies } from 'vue3-cookies';
import i18n from '@/plugins/i18n';
import { getFeatureErrorMessage } from '@/utils/featureErrors';

// These screens handle errors themselves. Keep the response metadata intact
// and avoid the legacy client's automatic toasts and redirects.
export default function createFeatureAxios(onError?: (error: unknown) => void) {
  const { cookies } = useCookies();
  const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://app.livelink.com.br';
  const client = axios.create({
    baseURL: API_BASE_URL,
    timeout: 60000,
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  });
  client.interceptors.request.use((request) => {
    const config = request;
    config.headers.Authorization = `Bearer ${cookies.get('access_token')}`;
    config.headers['Accept-Language'] = i18n.global.locale.value;
    return config;
  });
  client.interceptors.response.use((response) => response, async (cause) => {
    const error = cause;
    if (axios.isCancel(error)) throw error;
    if (error.response?.data instanceof Blob) {
      try {
        error.response.data = JSON.parse(await error.response.data.text());
      } catch {
        // Non-JSON bodies still receive the translated HTTP fallback.
      }
    }
    error.message = getFeatureErrorMessage(error);
    onError?.(error);
    throw error;
  });
  return client;
}
